"use strict";
/**
 * Sound.ts
 * Enumerate for play the sound
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sound = void 0;
var Sound;
(function (Sound) {
    Sound[Sound["CHECK"] = 1] = "CHECK";
    Sound[Sound["CALL"] = 2] = "CALL";
    Sound[Sound["BET"] = 3] = "BET";
    Sound[Sound["FOLD"] = 4] = "FOLD";
    Sound[Sound["WINNING"] = 5] = "WINNING";
    Sound[Sound["YOUR_TURN"] = 6] = "YOUR_TURN";
})(Sound || (exports.Sound = Sound = {}));
//# sourceMappingURL=Sound.js.map